import { twMerge } from "tailwind-merge";
import { ReactElement } from "react";
import { useShallow } from "zustand/react/shallow";
import { Icon } from "../../components";
import { Card } from "@sellar-io/components";
import { NavigationBarMenu } from "../../components/navigation/NavigationBar";
import {
  BuyerCreationFlowStep,
  useBuyerCreationFlowStore,
} from "../auth/signup/steps/BuyerCreationStep/BuyerCreationFlowStore";
import { BuyerCreationStep } from "../auth/signup/steps/BuyerCreationStep/BuyerCreationStep";

export function NewVenue(): ReactElement {
  const { step, setStep, postcode } = useBuyerCreationFlowStore(
    useShallow((state) => ({
      step: state.step,
      setStep: state.setStep,
      postcode: state.postcode,
    })),
  );
  return (
    <>
      <NavigationBarMenu title={"New venue"} />
      <div className={"m-auto mt-4 flex items-center lg:h-4/5"}>
        <Card
          className={twMerge(
            "bg-white",
            "m-auto flex h-screen flex-col overflow-auto lg:h-full lg:max-h-[768px] lg:w-[480px]",
          )}
        >
          {step?.backStep && postcode && (
            <div className="sticky top-0 z-10 bg-white px-8 pt-8 pb-4">
              <Icon
                className={"cursor-pointer"}
                icon={"CHEVRON_LEFT"}
                onClick={() => {
                  if (step.backStep) {
                    setStep(BuyerCreationFlowStep[step.backStep]);
                  }
                }}
              />
            </div>
          )}
          <div className="flex min-h-full flex-1 flex-col px-8 pb-8">
            <div className="flex flex-1 flex-col pb-8">
              <BuyerCreationStep lockEmail={true} />
            </div>
          </div>
        </Card>
      </div>
    </>
  );
}
